import React from "react";
import type { FC } from "react";

import { useFavouritesState } from "./FavouritesProvider.state";
import { FavouritesProviderContext } from "./FavouritesProvider.context";

const FavouritesProviderContextProvider = FavouritesProviderContext.Provider;

const FavouritesProvider: FC = (props) => {
  const { children } = props;

  const state = useFavouritesState();

  return <FavouritesProviderContextProvider value={state}>{children}</FavouritesProviderContextProvider>;
};

export { FavouritesProvider };
